import React from 'react';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { AnswerLink } from '../../components/Step/AnswerLink';
import { STEP_PROMOTION } from '../constants';
import type { SelectedValues } from '../config';
import type { PromotionValue } from './PromotionStepInputs';

interface PromotionStepAnswerProps {
    link: string;
    data: SelectedValues;
    onClick: () => void;
}

const answerCopy = (): Record<PromotionValue, string> => ({
    online: __('primarily online'),
    offline: __('primarily offline'),
    both: __('both offline and online'),
});

export function PromotionStepAnswer({ data, link, onClick }: PromotionStepAnswerProps) {
    const value = data[STEP_PROMOTION];

    if (!value) {
        return null;
    }

    return (
        <FormattedMessage
            message={__('I promote my brand {promotion}.')}
            values={{
                promotion: (
                    <AnswerLink href={link} onClick={onClick}>
                        {answerCopy()[value]}
                    </AnswerLink>
                ),
            }}
        />
    );
}
